import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col, Container, Row } from 'react-bootstrap';
import TextInput from './TextInput';

function TextInputDemo() {
  return (
    <Container>
      <Container className="mt-10">
        <Row>
          <Col className="mt-10 p-0">
            <h4>Text Input</h4>
            <Container className="d-flex justify-content-between flex-wrap p-0">
              <TextInput
                placeholder={'Sample Text'}
                label={'Sample label'}
                labelIcon
              />
              <TextInput
                defaultValue={'Sample Text'}
                label={'Sample label'}
                labelIcon
              />
              <TextInput
                placeholder={'Sample Text'}
                label={'Sample label'}
                disabled
              />
              <TextInput
                placeholder={'Sample Text'}
                label={'Sample label'}
                isValid={true}
              />
              <TextInput
                placeholder={'Sample Text'}
                label={'Sample label'}
                isInvalid={true}
              />
            </Container>
            <Container className="d-flex justify-content-between flex-wrap mt-10 p-0">
              <TextInput
                type={'password'}
                placeholder={'Password'}
                label={'Sample label'}
              />
              <TextInput
                type={'password'}
                defaultValue={'Sample Text'}
                label={'Sample label'}
              />
              <TextInput
                type={'password'}
                placeholder={'Password'}
                label={'Sample label'}
                disabled
              />
              <TextInput
                type={'password'}
                placeholder={'Password'}
                label={'Sample label'}
                isValid={true}
              />
              <TextInput
                type={'password'}
                placeholder={'Password'}
                label={'Sample label'}
                isInvalid={true}
              />
            </Container>
          </Col>
        </Row>
        <Row>
          <Col className="mt-10 p-0">
            <h4>Text Inputs with Icon</h4>
            <Container className="d-flex justify-content-between flex-wrap p-0">
              <TextInput
                rightIcon={light('magnifying-glass')}
                placeholder={'Search'}
                label={'Sample label'}
              />
              <TextInput
                rightIcon={light('magnifying-glass')}
                defaultValue={'Search'}
                label={'Sample label'}
              />
              <TextInput
                rightIcon={light('magnifying-glass')}
                placeholder={'Search'}
                label={'Sample label'}
                disabled
              />
              <TextInput
                rightIcon={light('magnifying-glass')}
                placeholder={'Search'}
                label={'Sample label'}
                isValid={true}
              />
              <TextInput
                rightIcon={light('magnifying-glass')}
                placeholder={'Search'}
                label={'Sample label'}
                isInvalid={true}
              />
            </Container>
            <Container className=" mt-10 d-flex justify-content-between flex-wrap p-0">
              <TextInput
                type={'tel'}
                leftIcon={light('phone')}
                placeholder={'Phone Number'}
              />
              <TextInput
                type={'tel'}
                leftIcon={light('phone')}
                defaultValue={'(222) 222-2222'}
              />
              <TextInput
                type={'tel'}
                leftIcon={light('phone')}
                placeholder={'Phone Number'}
                disabled
              />
              <TextInput
                type={'tel'}
                leftIcon={light('phone')}
                placeholder={'Phone Number'}
                isValid={true}
              />
              <TextInput
                type={'tel'}
                leftIcon={light('phone')}
                placeholder={'Phone Number'}
                isInvalid={true}
              />
            </Container>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default TextInputDemo;
